// extracted by mini-css-extract-plugin
export default {"tech-list":"TechList_tech-list__+0XUw","slide":"TechList_slide__DLq4x","tech-list__section":"TechList_tech-list__section__Z8Hb-"};